import React, { useEffect, useState } from 'react';
import './Footer.css';
import Logo from '../Logo/Logo';

const Footer = () => {
  const [location, setLocation] = useState({ region: '', country: '', loading: true });

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        setLocation({
          region: data.region || '',
          country: data.country_name || '',
          loading: false
        });
      } catch (error) {
        setLocation({ region: '', country: '', loading: false });
      }
    };
    fetchLocation();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-company">
            <Logo />
            <p className="company-description">
              Genix AI streamlines healthcare with real-time transcription, multilingual support, and smart insights.
            </p>
            <p className="copyright">
              © 2025 GENIX AI TECHNOLOGY INDIA PVT LTD . All rights reserved
            </p>
          </div>

          {/* Product Links */}
          <div className="footer-links">
            <h4>Product</h4>
            <ul>
              <li><a href="#genix-app">Genix App</a></li>
              <li><a href="#genix-pendant">Genix Pendant</a></li>
              <li><a href="#smart-badge">Genix Smart Badge</a></li>
            </ul>
          </div>

          {/* Resources Links */}
          <div className="footer-links">
            <h4>Resources</h4>
            <ul>
              <li><a href="#help">Help Center / Support</a></li>
              <li><a href="#blog">Blog / Insights</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="footer-social">
            <h4>Follow us</h4>
            <div className="social-icons">
              <a href="https://www.linkedin.com/company/genixai-healthcare/" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
                <svg viewBox="0 0 24 24">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                <svg viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Location at the very bottom */}
      <div className="footer-location-bar">
        <span className="footer-globe-icon" aria-label="Location">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#0191c6" strokeWidth="2"/><path d="M2 12h20M12 2c2.5 2.5 4 6.5 4 10s-1.5 7.5-4 10c-2.5-2.5-4-6.5-4-10s1.5-7.5 4-10z" stroke="#0191c6" strokeWidth="2"/></svg>
        </span>
        <span className="footer-location-text">
          {location.loading ? 'Detecting location...' : `${location.region ? location.region + ', ' : ''}${location.country}`}
        </span>
      </div>
    </footer>
  );
};

export default Footer; 